import { VxeUI } from 'vxe-pc-ui'
const showMessage = (res) => {
    if (res.success ) {
        VxeUI.modal.message({ content: res.message, status: 'success' })
        return true
    }
    else {
        VxeUI.modal.message({ content: res.message, status: 'error' })
        return false
    }
}
export default showMessage